export default {
  otherCategory: 'Andere ({count})',
};
